import actions from "~/shared/actions";

export function errorHandler() {
	return (next) => (action) => {
		const result = next(action);
		if (!["test", "production"].includes(process.env.NODE_ENV) && result.type === actions.ERROR && console) {
			// biome-ignore lint/suspicious/noConsole: intended dev-only logging
			console.error(action);
		}
		return result;
	};
}
